import React from "react";
import { Box, Typography } from "@mui/material";
import loading from "../../assets/images/loading.gif";

const ProcessingView = () => (
  <Box sx={{ textAlign: "center", mt: 4 }}>
    <Typography
      variant="h1"
      color="primary"
      sx={{
        fontFamily: "'Poppins-SemiBold', Helvetica",
        fontWeight: 600,
        fontSize: "39px",
        color: "#516d4f",
        mb: 2,
      }}
    >
      Finding a match...
    </Typography>
    <img
      src={loading}
      alt="Loading"
      style={{ width: "137px", height: "137px" }}
    />
  </Box>
);

export default ProcessingView;
